define(function(require, exports, module) {
    'use strict';

    module.exports = {
        getProductData: (name) => {
            if(typeof name !== 'string') {
                return [];
            }

            return name.split('---').map(item => item.trim());
        }
    };
});
